export class Something {
  id: number;
  partnerId: number;
  enterpriseId: number;
}
